import * as React from 'react';

import { IdentityContext } from '~/shared/providers/auth/IdentityContext';

export const useIdentity = () => {
  const context = React.useContext(IdentityContext);
  if (!context) {
    throw new Error('useIdentity must be used within an IdentityProvider');
  }
  return context;
};
